// Importación de imágenes
import taskflow from "../assets/proyectos/taskflow.png";
import SistemaCorreosCR from "../assets/proyectos/sistema_correos_costa_rica.png";
import CorreosRacket from "../assets/proyectos/correos_racket.png";
import pokedex from "../assets/proyectos/pokedex.png";

// Mapeo de imágenes para los proyectos
const projectImages = {
  "taskflow": taskflow,
  "sistema_correos": SistemaCorreosCR,
  "correos_racket": CorreosRacket,
  "pokedex": pokedex
};

export default projectImages;